/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconExclamationMark = createReactComponent("exclamation-mark", "IconExclamationMark", [
  ["path", { d: "M12 19v.01", key: "svg-0" }],
  ["path", { d: "M12 15v-10", key: "svg-1" }]
]);

export { IconExclamationMark as default };
//# sourceMappingURL=IconExclamationMark.js.map
